(() => {
  'use strict';
  if (!customElements.get('ec-fold-demo')) customElements.define('ec-fold-demo', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const buttons = [...this.querySelectorAll('[data-ec-mode]')];
      if (buttons.length !== 2) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const show = mode => {
        this.dataset.mode = mode;
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ecMode === mode)));
        this.querySelectorAll('[data-ec-photo]').forEach(photo => photo.setAttribute('aria-hidden', String(photo.dataset.ecPhoto !== mode)));
        this.querySelectorAll('[data-ec-caption]').forEach(caption => { caption.hidden = caption.dataset.ecCaption !== mode; });
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => show(button.dataset.ecMode), options);
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = buttons[event.key === 'Home' ? 0 : event.key === 'End' ? 1 : 1 - index];
          show(next.dataset.ecMode);
          next.focus();
        }, options);
      });
      this.querySelector('.ec-mode-controls').hidden = false;
      show(this.dataset.mode || 'open');
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
  if (!customElements.get('ec-photo-zoom')) customElements.define('ec-photo-zoom', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('[data-ec-zoom-open]');
      if (!dialog || !opener) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      opener.addEventListener('click', () => { if (!dialog.open) dialog.showModal(); }, options);
      this.querySelector('[data-ec-zoom-close]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, options);
      dialog.addEventListener('close', () => opener.focus({ preventScroll: true }), options);
    }
    disconnectedCallback() { this.querySelector('dialog[open]')?.close(); this.controller?.abort(); this.controller = null; }
  });
  if (!customElements.get('ec-buy-bar')) customElements.define('ec-buy-bar', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const root = this.closest('[data-ec-product]');
      const native = root?.querySelector('.product-form__submit');
      const button = this.querySelector('button');
      if (!native || !button) return;
      this.controller = new AbortController();
      const sync = () => {
        button.disabled = native.disabled || native.getAttribute('aria-disabled') === 'true';
        button.textContent = native.textContent.trim();
        this.querySelector('[data-ec-sticky-price]').textContent = (root.querySelector('.price-item--sale') || root.querySelector('.price-item--regular'))?.textContent.trim() || '';
      };
      const visibility = () => {
        const visible = native.getBoundingClientRect().bottom < 0;
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', String(!visible));
      };
      this.observer = new IntersectionObserver(visibility); this.observer.observe(native);
      this.mutation = new MutationObserver(sync); this.mutation.observe(native, {attributes:true,childList:true,subtree:true});
      window.addEventListener('scroll', visibility, {passive:true,signal:this.controller.signal});
      button.addEventListener('click', () => { if (!button.disabled) native.click(); }, {signal:this.controller.signal});
      sync(); visibility();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; this.observer?.disconnect(); this.mutation?.disconnect(); }
  });
})();
